module.exports = __webpack_public_path__ + "img/cns_printer_pc19.a98277b2.png";